var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var customlog = function (msg) {
    var option = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        option[_i - 1] = arguments[_i];
    }
    if (process.env.REACT_APP_DEBUG_MODE === "ON") {
        console.log.apply(console, __spreadArrays([msg], option));
    }
};
